import useAuthUser from "../../hooks/useAuthUser"
import getGender from "../../utils/getGender"
import getExamVersion from "../../utils/getExamVersion"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function PotensiKerjaFinish({ data }) {
    const { user } = useAuthUser()

    return (
        <>
            <div className="container mx-auto row items-center" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
                    <img src="/assets/images/login.svg" alt="" className="img-fluid w-100" style={{ maxWidth: "350px", objectFit: "contain" }} />
                    <div className="mt-5">
                        {/* <p className="text-secondary" style={{ fontSize: "1.2rem" }}>Selamat anda telah menyelesaikan seluruh rangkaian ujian.</p> */}
                        {data?.penilaian ? (
                            <>
                                <div dangerouslySetInnerHTML={{ __html: data?.penilaian }}></div>
                            </>
                        ) : (
                            <h3 className="mb-4 tw-uppercase" style={{ fontSize: "1.5rem", textTransform: "uppercase", lineHeight: 1.8, fontWeight: 700, }}>Selamat Anda Telah Menyelesaikan Test Potensi Kerja Versi {data?.data?.pk_hasil?.version?.version}.</h3>
                        )}
                    </div>
                </div>
                <div className="col-md-6 d-flex flex-column justify-content-center">
                    <div className="mt-2 border rounded p-5 bg-white">
                        <h1 className="fw-bold mb-5 text-center text-secondary" style={{ textTransform: "uppercase", fontSize: '1.5rem' }}>Ringkasan hasil ujian anda</h1>
                        <table className="table borderless" style={{ margin: "auto" }}>
                            <tbody>
                                <tr>
                                    <td>Nama</td>
                                    <td>{user?.nama_lengkap}</td>
                                </tr>
                                <tr>
                                    <td>No. Telepon</td>
                                    <td>{user?.no_tlp || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Alamat email</td>
                                    <td>{user?.email || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Tempat & Tanggal Lahir</td>
                                    <td>{user?.ttl || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Kelamin</td>
                                    <td>{getGender(user?.jenis_kelamin) || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Versi Ujian</td>
                                    <td>{getExamVersion(user?.version) || '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="row container mx-auto mt-3 mb-3 border rounded p-5 bg-white">
                <div className="row mx-auto mt-2">
                    <h2 className="text-center mb-5">Potensi Kerja</h2>
                </div>
                <div className="row mx-auto mt-2">
                    <Bar options={{
                        responsive: true,
                        plugins: {
                                legend: {
                                    display: false,
                                }
                            },
                            scales: {
                                x: {
                                    border: {
                                        display: false,
                                    },
                                    grid: {
                                        display: false,
                                    }
                                },
                                y: {
                                    border: {
                                        display: false
                                    },
                                }
                            }
                        }}
                        data={{
                            labels: data !== null ? Object.keys(data.hasil).map((key) => 'Kolom ' + key) : [],
                            datasets: data !== null ? [
                                {
                                    label: 'Benar',
                                    data: Object.values(data.hasil).map((value) => value['Benar']),
                                    backgroundColor: 'rgb(0, 204, 102)',
                                    borderRadius: 10,
                                },
                                {
                                    label: 'Salah',
                                    data: Object.values(data.hasil).map((value) => value['Salah']),
                                    backgroundColor: 'rgb(255, 99, 132)',
                                    borderRadius: 10,
                                },
                            ] : []
                        }}
                    />
                </div>
                <div className="row mx-auto my-5">
                    <table className="table table-bordered" style={{ margin: "auto" }}>
                        <thead>
                            <tr>
                                <th className="text-left">Kolom</th>
                                <th className="text-left">Benar</th>
                                <th className="text-left">Salah</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data !== null && Object.entries(data.hasil).map(([key, value]) => {
                                return (
                                    <tr key={key}>
                                        <td className="text-left">Kolom {key}</td>
                                        <td className="text-left">{value['Benar']}</td>
                                        <td className="text-left">{value['Salah']}</td>
                                    </tr>
                                )
                            })}
                            <tr>
                                <td className="text-left"><strong>Total</strong></td>
                                <td className="text-left"><strong>{data !== null ? Object.values(data.hasil).reduce((prev, curr) => prev + curr['Benar'], 0) : 0}</strong></td>
                                <td className="text-left"><strong>{data !== null ? Object.values(data.hasil).reduce((prev, curr) => prev + curr['Salah'], 0) : 0}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}